import { useCallback } from 'react';

import { IStore } from '@rbi-ctg/store';
import {
  GetRestaurantVrPaymentMerchantIdDocument,
  IGetRestaurantVrPaymentMerchantIdQuery,
} from 'generated/sanity-graphql';
import { useApolloClient } from 'state/graphql/hooks/use-sanity-query';
import { useSanityGqlEndpoint } from 'utils/network';

export const useFeatureRestaurantMerchantId = () => {
  const client = useApolloClient();
  const uri = useSanityGqlEndpoint();

  const getRestaurantVrPaymentMerchantId = useCallback(
    async (store: IStore): Promise<any> => {
      try {
        const response = await client.query<IGetRestaurantVrPaymentMerchantIdQuery>({
          query: GetRestaurantVrPaymentMerchantIdDocument,
          context: { uri },
          variables: {
            storeId: store._id,
          },
        });

        return response?.data?.Restaurant?.vrPaymentMerchantId;
      } catch (e) {
        return null;
      }
    },
    [client, uri]
  );

  return { getRestaurantVrPaymentMerchantId };
};
